/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminGroupSaleStatus = {
    GroupSaleStatusActive: 'active',
    GroupSaleStatusInactive: 'inactive',
    GroupSaleStatusComplete: 'complete',
    GroupSaleStatusCancelled: 'cancelled'
} as const;
export type AdminGroupSaleStatus = typeof AdminGroupSaleStatus[keyof typeof AdminGroupSaleStatus];


export function instanceOfAdminGroupSaleStatus(value: any): boolean {
    for (const key in AdminGroupSaleStatus) {
        if (Object.prototype.hasOwnProperty.call(AdminGroupSaleStatus, key)) {
            if (AdminGroupSaleStatus[key as keyof typeof AdminGroupSaleStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminGroupSaleStatusFromJSON(json: any): AdminGroupSaleStatus {
    return AdminGroupSaleStatusFromJSONTyped(json, false);
}

export function AdminGroupSaleStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGroupSaleStatus {
    return json as AdminGroupSaleStatus;
}

export function AdminGroupSaleStatusToJSON(value?: AdminGroupSaleStatus | null): any {
    return value as any;
}

export function AdminGroupSaleStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminGroupSaleStatus {
    return value as AdminGroupSaleStatus;
}

